// Module
var code = "<div id=\"dms-notification\"></div>\r\n<div>\r\n    <div class=\"dms-menu-layoutwrapper\"></div>\r\n    <div class=\"dms-maincontent-wrapper\">\r\n        <div class=\"dms-layout-wrapper\"></div>\r\n    </div>\r\n</div>\r\n";
// Exports
export default code;